
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fire-debris-removal",
      function () {
        return require("private-next-pages/fire-debris-removal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fire-debris-removal"])
      });
    }
  